import { memo, useEffect, useRef } from 'react'

import { setGlobalTargeting } from 'utils/ads'

export const InterstitialAd = memo(
  ({
    adUnitPath,
    customTargetings,
  }: {
    adUnitPath: string
    customTargetings?: {
      [key: string]: (string | number) | (string | number)[]
    }
  }) => {
    const adSlotRef = useRef<any>()
    useEffect(() => {
      window.googletag = window.googletag || { cmd: [] }
      const { googletag } = window
      googletag.cmd.push(function () {
        const slot = googletag.defineOutOfPageSlot(
          adUnitPath,
          googletag.enums.OutOfPageFormat.INTERSTITIAL,
        )
        adSlotRef.current = slot
        if (slot) {
          setGlobalTargeting(slot)
          slot.setTargeting('Pos', ['intersitial'])
          if (customTargetings) {
            Object.keys(customTargetings).forEach((k) => {
              if (k) slot.setTargeting(k, customTargetings[k])
            })
          }
          slot.addService(googletag.pubads())
          slot.setConfig({
            interstitial: {
              triggers: {
                unhideWindow: true,
              },
            },
          })
        }
      })
    }, [adUnitPath])
    return null
  },
  (prev, next) => prev.adUnitPath === next.adUnitPath,
)
